import { PageTemplate } from "@omni/types/enums/pageTemplate.enum";

import { isPageTemplate } from "@/utils/pageTemplate.utils";

import { Facet } from "./components/facet/@types/facet.types";
import { FacetType } from "./components/facet/@types/facetType.types";

type FacetFilterFn = (facet: Facet<FacetType>) => boolean;

const isCategoryPage = isPageTemplate(PageTemplate.ProductCategory);

const hierarchicalFacetFilter = (facet: Facet<FacetType>) => {
    const hasChildren =
        Object.keys(facet.values).length > 0 &&
        Object.keys(Object.values(facet.values).at(0)?.childValues || {})
            .length > 0;

    return !(isCategoryPage && !hasChildren);
};

const FiltersMap: Partial<Record<FacetType, FacetFilterFn>> = {
    [FacetType.HIERARCHICAL]: hierarchicalFacetFilter
};

export const filterFacets = (facet: Facet<FacetType>) => {
    const filter = FiltersMap[facet.type];
    if (filter) {
        return filter(facet);
    }

    return true;
};
